(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $ac3905202f0710b7$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}


function $753de3cb5925592a$export$71511d61b312f219(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}


function $2f97c2a4ea6269f4$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $753de3cb5925592a$export$71511d61b312f219)(receiver, privateMap, "get");
    return (0, $ac3905202f0710b7$export$71511d61b312f219)(receiver, descriptor);
}


function $f86983e96b0c893e$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $5d6c3530fa14a187$export$71511d61b312f219(obj, privateMap, value) {
    (0, $f86983e96b0c893e$export$71511d61b312f219)(obj, privateMap);
    privateMap.set(obj, value);
}


function $a91e4d47d6e0e68a$export$71511d61b312f219(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}



function $20d5c04b0c6865c9$export$71511d61b312f219(receiver, privateMap, value) {
    var descriptor = (0, $753de3cb5925592a$export$71511d61b312f219)(receiver, privateMap, "set");
    (0, $a91e4d47d6e0e68a$export$71511d61b312f219)(receiver, descriptor, value);
    return value;
}


function $ac6739cbe5bf1c84$export$71511d61b312f219(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}



function $ea91727f98d0802f$export$71511d61b312f219(obj, privateSet) {
    (0, $f86983e96b0c893e$export$71511d61b312f219)(obj, privateSet);
    privateSet.add(obj);
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


"use strict";
var /**
   * Creates a new game instance.
   *
   * @param {number[][]} initialState
   * The initial state of the board.
   * @default
   * [[0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0]]
   *
   * If passed, the board will be initialized with the provided
   * initial state.
   */ $3d28d7f1aac198f5$var$_size = /*#__PURE__*/ new WeakMap(), $3d28d7f1aac198f5$var$_board = /*#__PURE__*/ new WeakMap(), $3d28d7f1aac198f5$var$_score = /*#__PURE__*/ new WeakMap(), $3d28d7f1aac198f5$var$_status = /*#__PURE__*/ new WeakMap(), $3d28d7f1aac198f5$var$_wonValue = /*#__PURE__*/ new WeakMap(), $3d28d7f1aac198f5$var$_empty = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_randomNull = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_spawn = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_move = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_serialize = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_reconstructor = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_backconstructor = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_winValue = /*#__PURE__*/ new WeakSet(), $3d28d7f1aac198f5$var$_canMove = /*#__PURE__*/ new WeakSet();
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_empty);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_randomNull);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_spawn);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_move);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_serialize);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_reconstructor);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_backconstructor);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_winValue);
        (0, $ea91727f98d0802f$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_canMove);
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_size, {
            writable: true,
            value: 4
        });
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board, {
            writable: true,
            value: void 0
        });
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_score, {
            writable: true,
            value: 0
        });
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_status, {
            writable: true,
            value: "idle"
        }) // idle | playing | win | lose
        ;
        (0, $5d6c3530fa14a187$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_wonValue, {
            writable: true,
            value: 2048
        });
        (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board, (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_empty, $3d28d7f1aac198f5$var$empty).call(this));
        if (Array.isArray(initialState)) (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board, initialState.map(function(row) {
            return row.slice();
        }));
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                return (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_move, $3d28d7f1aac198f5$var$move).call(this, "left");
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                return (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_move, $3d28d7f1aac198f5$var$move).call(this, "right");
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                return (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_move, $3d28d7f1aac198f5$var$move).call(this, "up");
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                return (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_move, $3d28d7f1aac198f5$var$move).call(this, "down");
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_score);
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board).map(function(row) {
                    return row.slice();
                });
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_status);
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_score, 0);
                (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_status, "playing");
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_spawn, $3d28d7f1aac198f5$var$spawn).call(this);
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_spawn, $3d28d7f1aac198f5$var$spawn).call(this);
                return this.getState();
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board, (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_empty, $3d28d7f1aac198f5$var$empty).call(this));
                (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_score, 0);
                (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_status, "playing");
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_spawn, $3d28d7f1aac198f5$var$spawn).call(this);
                (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_spawn, $3d28d7f1aac198f5$var$spawn).call(this);
                return this.getState();
            }
        }
    ]);
    return Game;
}();
function $3d28d7f1aac198f5$var$empty() {
    var _this = this;
    return Array.from({
        length: (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_size)
    }, function() {
        return Array((0, $2f97c2a4ea6269f4$export$71511d61b312f219)(_this, $3d28d7f1aac198f5$var$_size)).fill(0);
    });
}
function $3d28d7f1aac198f5$var$randomNull() {
    var arrNulls = [];
    for(var i = 0; i < (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_size); i++){
        for(var j = 0; j < (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_size); j++)if ((0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board)[i][j] === 0) arrNulls.push([
            i,
            j
        ]);
    }
    if (arrNulls.length === 0) return null;
    return arrNulls[Math.floor(Math.random() * arrNulls.length)];
}
function $3d28d7f1aac198f5$var$spawn() {
    var cord = (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_randomNull, $3d28d7f1aac198f5$var$randomNull).call(this);
    if (!cord) return false;
    (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board)[cord[0]][cord[1]] = Math.random() < 0.9 ? 2 : 4;
    return true;
}
function $3d28d7f1aac198f5$var$move(direction) {
    if ((0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_status) !== "playing") return false;
    var beforeBoard = (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_serialize, $3d28d7f1aac198f5$var$serialize).call(this, (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board));
    var scoreMove = 0;
    var shift = function(line) {
        var newLine = line.filter(function(num) {
            return num !== 0;
        });
        var scoreLine = 0;
        for(var i = 0; i < newLine.length - 1; i++)if (newLine[i] === newLine[i + 1]) {
            newLine[i] = newLine[i] * 2;
            newLine[i + 1] = 0;
            scoreLine += newLine[i];
        }
        var finalLine = newLine.filter(function(num) {
            return num !== 0;
        });
        return {
            calculateLine: finalLine,
            scoreRes: scoreLine
        };
    };
    if (direction === "left" || direction === "right") {
        var i = 0;
        while(i < (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board).length){
            var row = (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board)[i];
            var _shift = shift(row), calculateLine = _shift.calculateLine, scoreRes = _shift.scoreRes;
            var arr = calculateLine;
            scoreMove += scoreRes;
            if (direction === "left") while(arr.length < 4)arr.push(0);
            else while(arr.length < 4)arr.unshift(0);
            (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board)[i] = arr;
            i++;
        }
    } else {
        var i1 = 0;
        var newBoard = [];
        var reconstructBord = (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_reconstructor, $3d28d7f1aac198f5$var$reconstructor).call(this);
        while(i1 < reconstructBord.length){
            var row1 = reconstructBord[i1];
            var _shift1 = shift(row1), calculateLine1 = _shift1.calculateLine, scoreRes1 = _shift1.scoreRes;
            var arr1 = calculateLine1;
            scoreMove += scoreRes1;
            if (direction === "up") while(arr1.length < 4)arr1.push(0);
            else while(arr1.length < 4)arr1.unshift(0);
            newBoard.push(arr1);
            i1++;
        }
        (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board, (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_backconstructor, $3d28d7f1aac198f5$var$backconstructor).call(this, newBoard));
    }
    if ((0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_winValue, $3d28d7f1aac198f5$var$winValue).call(this)) (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_status, "win");
    var afterBoard = (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_serialize, $3d28d7f1aac198f5$var$serialize).call(this, (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board));
    if (beforeBoard !== afterBoard) {
        (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_score, (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_score) + scoreMove);
        (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_spawn, $3d28d7f1aac198f5$var$spawn).call(this);
        if (!(0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_canMove, $3d28d7f1aac198f5$var$canMove).call(this)) {
            (0, $20d5c04b0c6865c9$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_status, "lose");
            return false;
        }
        return true;
    }
    return false;
}
function $3d28d7f1aac198f5$var$serialize(b) {
    return b.flat().join(",");
}
function $3d28d7f1aac198f5$var$reconstructor() {
    var reconstructBoard = [];
    var lineBord = (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board).flat();
    for(var i = 0; i < (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_size); i++){
        var row = [
            lineBord[i],
            lineBord[i + 4],
            lineBord[i + 8],
            lineBord[i + 12]
        ];
        reconstructBoard.push(row);
    }
    return reconstructBoard;
}
function $3d28d7f1aac198f5$var$backconstructor(matrix) {
    var backBoard = [];
    for(var r = 0; r < (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_size); r++){
        var row = [];
        for(var c = 0; c < (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_size); c++)row.push(matrix[c][r]);
        backBoard.push(row);
    }
    return backBoard;
}
function $3d28d7f1aac198f5$var$winValue() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board)[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var row = _step.value;
            try {
                for(var _iterator1 = row[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var val = _step1.value;
                    if (val === (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_wonValue)) return true;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
}
function $3d28d7f1aac198f5$var$canMove() {
    var upDown = (0, $ac6739cbe5bf1c84$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_reconstructor, $3d28d7f1aac198f5$var$reconstructor).call(this);
    if ((0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board).some(function(row) {
        return row.includes(0);
    })) return true;
    for(var i = 0; i < (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_size); i++)for(var j = 0; j < (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_size) - 1; j++){
        if ((0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board)[i][j] === (0, $2f97c2a4ea6269f4$export$71511d61b312f219)(this, $3d28d7f1aac198f5$var$_board)[i][j + 1] || upDown[i][j] === upDown[i][j + 1]) return true;
    }
    return false;
}
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


"use strict";
var $197cd56b15c33885$var$game = new (0, (/*@__PURE__*/$parcel$interopDefault($3d28d7f1aac198f5$exports)))();
var $197cd56b15c33885$var$score = document.querySelector(".game-score");
var $197cd56b15c33885$var$btn = document.querySelector(".button.start");
var $197cd56b15c33885$var$lose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$win = document.querySelector(".message-win");
var $197cd56b15c33885$var$start = document.querySelector(".message-start");
var $197cd56b15c33885$var$tr = document.querySelectorAll(".field-row");
function $197cd56b15c33885$var$render() {
    var uiBoard = $197cd56b15c33885$var$game.getState();
    $197cd56b15c33885$var$score.textContent = $197cd56b15c33885$var$game.getScore();
    for(var i = 0; i < 4; i++){
        var cells = $197cd56b15c33885$var$tr[i].querySelectorAll(".field-cell");
        for(var j = 0; j < 4; j++){
            var cell = cells[j];
            var value = uiBoard[i][j];
            cell.textContent = "";
            cell.className = "field-cell";
            if (value !== 0) {
                cell.textContent = value;
                cell.classList.add("field-cell--".concat(value));
            }
        }
    }
    if ($197cd56b15c33885$var$game.getStatus() === "idle") {
        $197cd56b15c33885$var$btn.classList.add("start");
        $197cd56b15c33885$var$btn.classList.remove("restart");
        $197cd56b15c33885$var$btn.textContent = "Start";
    } else {
        $197cd56b15c33885$var$btn.classList.add("restart");
        $197cd56b15c33885$var$btn.classList.remove("start");
        $197cd56b15c33885$var$btn.textContent = "Restart";
    }
    // eslint-disable-next-line no-console
    console.log($197cd56b15c33885$var$game.getStatus());
    if ($197cd56b15c33885$var$game.getStatus() !== "idle") {
        $197cd56b15c33885$var$start.classList.add("hidden");
        if ($197cd56b15c33885$var$game.getStatus() === "lose") $197cd56b15c33885$var$lose.classList.remove("hidden");
        if ($197cd56b15c33885$var$game.getStatus() === "win") $197cd56b15c33885$var$win.classList.remove("hidden");
    } else {
        $197cd56b15c33885$var$start.classList.remove("hidden");
        $197cd56b15c33885$var$lose.classList.add("hidden");
        $197cd56b15c33885$var$win.classList.add("hidden");
    }
}
$197cd56b15c33885$var$btn.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "idle") $197cd56b15c33885$var$game.start();
    else {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$lose.classList.add("hidden");
    }
    $197cd56b15c33885$var$render();
});
document.addEventListener("keydown", function(e) {
    var key = e.key;
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    switch(key){
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
        default:
            break;
    }
    $197cd56b15c33885$var$render();
});
$197cd56b15c33885$var$render();

})();
//# sourceMappingURL=index.e1813fec.js.map
